import {memo} from "react";

export const CheckboxChecked = memo(({className, ...props}) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM4.5 19.5V4.5H19.5V19.5H4.5Z"
        fill="currentColor"
      />
      <path
        d="M10.5 16.125L6.75 12.405L7.9425 11.25L10.5 13.7625L16.0575 8.25L17.25 9.435L10.5 16.125Z"
        fill="currentColor"
      />
    </svg>
  );
});

CheckboxChecked.displayName = "CheckboxChecked";
